var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.282,
    height: 3.275,
    viewBox: "0 0 15.282 3.275",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-minus",
    "data-name": "Icon awesome-minus",
    d: "M14.191,14.625H1.092A1.092,1.092,0,0,0,0,15.717v1.092A1.092,1.092,0,0,0,1.092,17.9h13.1a1.092,1.092,0,0,0,1.092-1.092V15.717A1.092,1.092,0,0,0,14.191,14.625Z",
    transform: "translate(0 -14.625)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMinus);
export default __webpack_public_path__ + "static/media/icon-minus.5215695aed4736151051717ade1ae904.svg";
export { ForwardRef as ReactComponent };